import {
  Backdrop,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { FiAlertOctagon } from "react-icons/fi";
import PropTypes from "prop-types"; // ✅ import

const DeleteForm = ({ isOpen, handleDelete, onHandleClose, isSubmitting }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(isOpen);

  React.useEffect(() => {
    setOpen(isOpen); // Sync local state with prop
  }, [isOpen]);

  return (
    <Modal
      open={open}
      onClose={onHandleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Dialog
        open={open}
        onClose={onHandleClose}
        TransitionProps={{ onExited: () => setOpen(false) }}
        closeAfterTransition
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .css-2eq1dx-MuiPaper-root-MuiDialog-paper": {
            backgroundColor: theme.palette.background.form,
          },
        }}
      >
        <DialogTitle
          component="div"
          sx={{
            backgroundColor: theme.palette.background.form,
            borderBottom: `1px solid ${theme.palette.background.border}`,
          }}
        >
          <Typography variant="h6" color={theme.palette.mode === "dark" ? "#fff" : "#000"}>
            Are you sure you want to delete this?
          </Typography>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            width: "100%",
            maxHeight: { xs: "70vh", sm: "400px" },
            overflow: "auto",
            padding: "8px 16px",
            backgroundColor: theme.palette.background.form,
            color: theme.palette.text.norecords,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            wordBreak: "break-word",
          }}
        >
          <Typography
            variant="body1"
            color={theme.palette.mode === "dark" ? "#fff" : "#000"}
            sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, lineHeight: 1.5, mb: 2 }}
          >
            This is a permanent deletion. Once completed, your data will be lost forever and cannot
            be retrieved.
          </Typography>
          <FiAlertOctagon size={30} />
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: theme.palette.background.form,
            padding: "8px 16px",
            borderTop: `1px solid ${theme.palette.background.border}`,
          }}
        >
          <Button onClick={onHandleClose} color="error" variant="contained" size="medium">
            No
          </Button>
          <Button
            disabled={isSubmitting}
            onClick={handleDelete}
            color="primary"
            variant="contained"
            size="medium"
            sx={{ color: "#fff" }} // ✅ sets text color to white
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Modal>
  );
};

DeleteForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  onHandleClose: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default DeleteForm;
